import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ComparisonSection } from './components/ComparisonSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { FAQSection } from './components/FAQSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { BorerIdentificationSection } from './components/BorerIdentificationSection';
import { Dashboard } from './pages/Dashboard';
import { useAnalytics } from './hooks/useAnalytics';

// Main landing page component
const LandingPage = () => {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <BorerIdentificationSection />
        <BenefitsSection />
        <ComparisonSection />
        <HowItWorksSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
};

// Wrapper component that includes analytics
const AnalyticsWrapper = ({ children }) => {
  useAnalytics();
  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AnalyticsWrapper>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            {/* Analytics dashboard - access via preview URL /dashboard */}
            <Route path="/dashboard" element={<Dashboard />} />
          </Routes>
        </AnalyticsWrapper>
      </BrowserRouter>
    </div>
  );
}

export default App;
